// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"UTG3H2kQloKyyEmR-Ab4X"};